/**
 * The login screens' copy for `account_blocked_inactivity`. The API sends it
 * only after the password checked out, with the tenant's configured window.
 */
export function inactivityBlockedMessage(data: { days?: number } | undefined): string {
  const days = data?.days;
  const span = !days || days === 365 ? 'a year' : `${days} days`;
  return `Your account was blocked after ${span} with no new direct and no repeat purchase. Please contact us to have it reactivated.`;
}
